import React from "react";
import { RichTextEditor } from "../../../components/RichTextEditor";
import * as S from "../styles";

const API_URL = process.env.REACT_APP_API_URL || "";

const PaperFields = ({
  formData,
  setFormData,
  handleSavePaper,
  saving,
  showMessage,
  handleOriginalClick,
}) => {
  return (
    <S.Section>
      <S.SectionTitle>Редактор</S.SectionTitle>

      <S.FormGrid>
        <S.FormGroup className="full-width">
          <S.Label>Изображение бумаги</S.Label>
          <S.OriginalPreview>
            <S.PreviewImageWrapper onClick={handleOriginalClick}>
              {formData.original ? (
                <S.PreviewImage
                  src={`${API_URL}/images/${formData.original}`}
                  alt="original"
                />
              ) : (
                <S.EmptyPreview>Нет изображения</S.EmptyPreview>
              )}
              <S.PreviewOverlay>
                {formData.original
                  ? "Нажмите для замены"
                  : "Нажмите для загрузки"}
              </S.PreviewOverlay>
            </S.PreviewImageWrapper>
          </S.OriginalPreview>
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Название типа бумаги</S.Label>
          <S.Input
            type="text"
            value={formData.name}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, name: e.target.value }))
            }
          />
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Дополнительные термины</S.Label>
          <S.Input
            type="text"
            value={formData.lists}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, lists: e.target.value }))
            }
          />
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Текст статьи</S.Label>
          <RichTextEditor
            value={formData.text}
            showMessage={showMessage}
            onChange={(html) =>
              setFormData((prev) => ({ ...prev, text: html }))
            }
          />
        </S.FormGroup>
      </S.FormGrid>

      <S.SaveButton onClick={handleSavePaper} disabled={saving}>
        {saving ? "Сохранение..." : "Сохранить изменения"}
      </S.SaveButton>
    </S.Section>
  );
};

export default PaperFields;
